export default __webpack_public_path__ + "media/Seasoning-Vinegar.ba52690e.png";